"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProduct = fetchProduct;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
// Shopify doc link: https://shopify.dev/docs/api/ajax/reference/product#get-locale-products-product-handle-js
function fetchProduct() {
  return _fetchProduct.apply(this, arguments);
}
function _fetchProduct() {
  _fetchProduct = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var path, response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          path = window.location.pathname;
          _context.next = 4;
          return fetch("".concat(path, ".js"));
        case 4:
          response = _context.sent;
          _context.next = 7;
          return response.json();
        case 7:
          return _context.abrupt("return", _context.sent);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          console.error("Error fetching product:", _context.t0);
          return _context.abrupt("return", {
            items: []
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _fetchProduct.apply(this, arguments);
}
//# sourceMappingURL=product.js.map
